export default __webpack_public_path__ + "static/media/back-icon.2a21fd81.svg";